<template>
  <b-row>
    <b-col>
      <h6 class="compo-heading">{{ $t('special category.specialcategory') }}</h6>
    </b-col>
  </b-row>
  <div class="checkbox-details-card">
    <b-row>
      <b-col lg="12" md="12" sm="12" cols="12">
        <!-- <n-space vertical>
                    <n-checkbox label="Sheduled Item" v-model:checked="SpecialCategory.ScheduledItem" />
                    <n-checkbox label="Narcotic Item" v-model:checked="SpecialCategory.NarcoticItem" />
                    <n-checkbox label="Drug Formulary" v-model:checked="SpecialCategory.DrugFormulary" />
                    <n-checkbox label="Critical Medicine" v-model:checked="SpecialCategory.CriticalMedicine" />
                    <n-checkbox label="Alike" v-model:checked="SpecialCategory.Alike" />
                </n-space> -->

        <div class="justify-content-center gap-5">
          <div class="flex align-items-center pt-2">
            <Checkbox v-model="SpecialCategory.ScheduledItem" inputId="ingredient1" name="Sheduled Item" value="true"
              :tabindex="22" />
            <label for="ingredient1" class="ms-2"> {{ $t('special category.sheduleditem') }}</label>
          </div>
          <div class="flex align-items-center pt-2">
            <Checkbox v-model="SpecialCategory.NarcoticItem" inputId="ingredient2" name=" Narcotic Item" value="true"
              :tabindex="23" />
            <label for="ingredient2" class="ms-2"> {{ $t('special category.narcoticitem') }} </label>
          </div>
          <div class="flex align-items-center pt-2">
            <Checkbox v-model="SpecialCategory.DrugFormulary" inputId="ingredient3" name="Drug Formulary" value="true"
              :tabindex="24" />
            <label for="ingredient3" class="ms-2"> {{ $t('special category.drugformulary') }} </label>
          </div>
          <div class="flex align-items-center pt-2">
            <Checkbox v-model="SpecialCategory.CriticalMedicine" inputId="ingredient4" name="Critical Medicine"
              value="true" :tabindex="25" />
            <label for="ingredient4" class="ms-2"> {{ $t('special category.criticalmedicine') }} </label>
          </div>
          <div class="flex align-items-center pt-2">
            <Checkbox v-model="SpecialCategory.Alike" inputId="ingredient4" name="Alike" value="true" :tabindex="26" />
            <label for="ingredient4" class="ms-2"> {{ $t('special category.alike') }} </label>
          </div>
        </div>
      </b-col>
    </b-row>
    <b-row>
      <b-col lg="8" md="8" sm="8" cols="10" class="my-3 mx-5">
        <!-- <n-select v-model:value="selectedValue" :options="options" clearable placeholder="Select" /> -->
        <div class="field">
          <CustomDropDown v-model="SpecialCategory.SpecialCategoryItemId" :items="AllItemDropdown.Itemoption"
            @change="AllItemOnChange" :tabindex="27" />
        </div>
      </b-col>
    </b-row>

    <b-row
      v-if="Array.isArray(SpecialCategory.ScheduledItem) ? SpecialCategory.ScheduledItem.length > 0 : SpecialCategory.ScheduledItem">
      <b-col lg="8" md="8" sm="8" cols="10" class="mx-5">
        <!-- <n-select v-model:value="selectedValue" :options="options" clearable placeholder="Select" /> -->
        <div class="field">
          <CustomDropDown v-model="SpecialCategory.ScheduledId" :items="ScheduledDropdown.Itemoption" :name="$t(
            'special category.schedule')" :id="$t('special category.schedule')"
            :label="$t('special category.schedule')" @change="input" :tabindex="40"
            :rules="{ required: Array.isArray(SpecialCategory.ScheduledItem) ? SpecialCategory.ScheduledItem.length > 0 : SpecialCategory.ScheduledItem }"
            :required-icon="Array.isArray(SpecialCategory.ScheduledItem) ? SpecialCategory.ScheduledItem.length > 0 : SpecialCategory.ScheduledItem" />
        </div>
      </b-col>
    </b-row>
  </div>
</template>

<script lang="ts">
import { defineComponent, ref, reactive, toRefs, onMounted } from "vue";
import CustomDropDown from "../../../../components/FormComponents/Dropdown.vue";
import service from "../../../../../src/modules/Inventory/Service/ItemMasService";
import CommonService from "../../../../modules/Inventory/Service/CommonService";
export default defineComponent({
  components: {
    CustomDropDown,
  },
  props: {
    value: Object,
  },

  methods: {},
  setup(props, { emit }) {
    let session: any = localStorage.getItem('UsersData')

    session = JSON.parse(session)
    let HospitalId = Number(session.OrganizationId);
    let BranchId = Number(session.BranchId);
    let UserId = Number(session.UserId);
    let SpecialCategory = reactive({
      ScheduledItem: false,
      NarcoticItem: false,
      DrugFormulary: false,
      CriticalMedicine: false,
      Alike: false,
      SpecialCategoryItemId: ref(),
      ScheduledId: ref()
    });

    onMounted(() => {
      debugger;
      LoadItems();
      LoadSchedule();
      Object.assign(Object.assign(SpecialCategory), props.value);
      input();
    });

    function input() {
      //emit('update:value', SpecialCategory)
      emit("update:checked", SpecialCategory);
    }

    //Load Manufactures
    const AllItemDropdown = ref({
      Itemid: null,
      Itemoption: [],
    });

    //Load Manufactures
    const ScheduledDropdown = ref({
      Itemid: null,
      Itemoption: [],
    });

    async function LoadItems() {
      debugger;
      try {
        const data_response = await service.getdata(HospitalId);
        console.log(data_response);
        AllItemDropdown.value.Itemoption = data_response["result"]
          .filter((f) => f.IsActive == true && f.HospitalId == HospitalId && f.BranchId == BranchId)
          .map((item) => {
            item.name = item.ItemName;
            item.value = item.Id;
            return item;
          });
      } catch (error) {
        alert(error);
      }
      input();
    }

    //All Item On Change
    const AllItemOnChange = (value: any, option: Selection) => {
      debugger;
      SpecialCategory.SpecialCategoryItemId = value.value;
    };


    const LoadSchedule = async () => {
      try {
        const data_response = await CommonService.ScheduleList();
        console.log(data_response);
        ScheduledDropdown.value.Itemoption = data_response["result"].map((item) => {
          item.name = item.Name;
          item.value = item.Id;
          return item;
        });
      } catch (error) {
        alert(error);
      }
      input();
    }




    return {
      selectedValue: ref(),
      selectedArray: ref([]),
      options: [
        {
          name: "Select1",
          code: "select1",
        },
        {
          name: "Select2",
          code: "select2",
        },
        {
          name: "Select3",
          code: "select3",
        },
      ],

      SpecialCategory,
      input,
      LoadItems,
      AllItemDropdown,
      AllItemOnChange,
      ScheduledDropdown
    };
  },
});
</script>
<style lang="scss">
.checkbox-details-card {
  background-color: #fcfcfc;
  border: 1px solid #fafafa;
  padding: 15px;
  border-radius: 10px;
  font-size: 14px;
}
</style>
